const stage = 'beta';

export const getCurrentStage = (): string => {
    return stage;
};

export const envConfig = {
    Auth: {
        identityPoolId: 'us-west-2:208c64e2-1f7c-47f7-bd3c-bb4391628eb2',
        region: 'us-west-2',
        userPoolId: 'us-west-2_Kh6LrcCUL',
        userPoolWebClientId: '66gdmfgtmpsgqqsj5s8ai5b0hj',
        mandatorySignIn: true,
        oauth: {
            domain: 'finspace-beta' + '.auth.us-west-2.amazoncognito.com',
            redirectSignIn: 'https://' + window.location.host + '/',
            redirectSignOut: 'https://' + window.location.host+ '/',
            scope: ['openid'],
            responseType: 'code',
        },
    },
    API: {
        endpoints: [
            {
                name: 'FinSpaceService',
                endpoint: `https://api.${stage}.service.finspace.finergy.amazon.dev`,
                region: 'us-west-2',
            },
        ],
    },
    Storage: {
        AWSS3: {
            bucket: `finspace-transfer-${stage}`,
            region: 'us-west-2',
        },
    },
};
